import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const BEFORE_AFTER_IMG =
  "https://customer-assets.emergentagent.com/job_scharpf-goldankauf/artifacts/ntuiogvu_6E619CAD-CF5B-488C-BC45-0BBF05FA3561.png";

export default function BeforeAfter() {
  return (
    <section id="vorher-nachher" className="relative bg-surface py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-navy text-xs font-bold uppercase tracking-[0.2em] ring-1 ring-slate-200">
            <Sparkles className="w-3.5 h-3.5" style={{ color: "#4ea83a" }} />
            Vorher / Nachher
          </div>
          <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-black text-navy tracking-tight leading-[1.05]">
            Echte Ergebnisse —{" "}
            <span className="text-shine">unsere Arbeit spricht für sich.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Vom verwahrlosten Dachboden bis zum vollgestellten Keller — wir hinterlassen Ihre Räume
            besenrein und übergabefertig. Sehen Sie selbst, was wir bei echten Aufträgen geleistet haben.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-12 relative"
          data-testid="before-after-grid"
        >
          <div className="relative rounded-[2rem] overflow-hidden bg-white shadow-2xl ring-1 ring-slate-200">
            <img
              src={BEFORE_AFTER_IMG}
              alt="Vorher Nachher Vergleich – Entrümpelung von Dachboden, Keller und Wohnräumen durch Scharpf"
              className="w-full h-auto object-contain"
              loading="lazy"
            />
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              { num: "4", label: "Echte Vorher-Nachher-Beispiele" },
              { num: "100%", label: "Besenreine Übergabe" },
              { num: "0", label: "Versteckte Kosten" },
            ].map((s) => (
              <div
                key={s.label}
                className="p-5 rounded-2xl bg-white ring-1 ring-slate-200 shadow-sm flex items-center gap-4"
              >
                <div className="font-heading text-4xl font-black text-navy">{s.num}</div>
                <div className="text-sm font-semibold text-slate-700 leading-snug">{s.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
